import styled from "@emotion/styled";

export const TypographyT1 = styled.h1`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const TypographyT2 = styled.h2`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const TypographyT3 = styled.h3`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const TypographyT4 = styled.h4`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const TypographyT5 = styled.h5`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const TypographyT6 = styled.h6`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const TypographyT7 = styled(TypographyT3)`
  font-weight: 400;
  text-align: center;
`;

export const TypographyT8 = styled(TypographyT5)`
  color: #fff;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
`;

export const TypographyT9 = styled(TypographyT5)`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;

export const TypographyT10 = styled(TypographyT5)`
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const TypographyT11 = styled(TypographyT5)`
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
`;

export const TypographyT12 = styled(TypographyT5)`
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  padding: 8px;
  border: 1px solid #fff;
  border-radius: 4px;
  width: fit-content;
`;
export const TypographyT13 = styled(TypographyT4)`
  color: #27335d;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
export const TypographyT14 = styled(TypographyT4)`
  color: #677586;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;

export const TypographyT15 = styled(TypographyT5)`
  color: #27335d;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
export const TypographyT16 = styled(TypographyT5)`
  color: #677586;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;
export const TypographyT17 = styled(TypographyT5)`
  color: #ec6263;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
`;
export const TypographyT18 = styled(TypographyT5)`
  color: ${({ color }) => (!!color ? color : "#4e9757")};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;
export const TypographyT19 = styled(TypographyT5)`
  color: ${({ color }) => (!!color ? color : " #528AEA")};
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  align-items: center;
`;

export const TypographyT20 = styled(TypographyT5)`
  color: ${({ color }) => (!!color ? color : " #528AEA")};
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
`;

export const TypographyT21 = styled(TypographyT5)`
  color: #fff;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  background-color: ${({ bgColor }) => (!!bgColor ? bgColor : " #FF9900")};
  padding: 2px 8px;
  border-radius: 3px;
`;

export const TypographyT22 = styled(TypographyT5)`
  color: #163760;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;
export const TypographyT23 = styled(TypographyT5)`
  color: ${({ color }) => (!!color ? color : "#677586")};
  font-family: Poppins;
  font-size: ${({ fontSize }) => (!!fontSize ? fontSize : "16px")};
  font-style: normal;
  font-weight: ${({ fontWeight }) => (!!fontWeight ? fontWeight : "600")};
  line-height: 18px;
`;

export const TypographyT24 = styled(TypographyT5)`
  color: #000;
  font-family: Poppins;
  font-size: ${({ fontSize }) => (!!fontSize ? fontSize : "16px")};
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const TypographyT25 = styled(TypographyT5)`
  color: ${({ color }) => (!!color ? color : "#4e9757")};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;
export const TypographyT26 = styled(TypographyT5)`
  color: #163760;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
`;

export const TypographyT27 = styled(TypographyT5)`
  color: #163760;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.48px;
`;

export const TypographyT28 = styled(TypographyT5)`
  color: #191919;
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
`;

export const TypographyT29 = styled(TypographyT5)`
  color: #677586;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`;
export const TypographyT30 = styled(TypographyT5)`
  color: #27335d;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`;
export const TypographyT31 = styled(TypographyT5)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;
export const TypographyT32 = styled(TypographyT3)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
`;

export const TypographyT33 = styled(TypographyT5)`
  color: #0c06f7;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
`;

export const TypographyT34 = styled(TypographyT5)`
  color: #14223a;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  border-radius: 2px;
  border: 1px solid rgba(82, 138, 234, 0.75);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 100%),
    #f6f9ff;
  padding: 2px 4px;
  width: fit-content;
`;
export const TypographyT35 = styled(TypographyT3)`
  font-weight: 600;
  font-size: 1rem;
  line-height: 18px;
  color: ${({ color }) => (!!color ? color : "var(--color06)")};
`;
export const TypographyT36 = styled(TypographyT4)`
  color: #0c06f7;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;
export const TypographyT37 = styled(TypographyT4)`
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;
export const TypographyT38 = styled(TypographyT4)`
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.24px;
`;
export const TypographyT39 = styled(TypographyT6)`
  color: #677586;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
export const TypographyT40 = styled(TypographyT6)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;
export const TypographyT41 = styled(TypographyT40)`
  color: #038c42;
`;
export const TypographyT42 = styled(TypographyT40)`
  color: #f00;
`;

export const TypographyT43 = styled(TypographyT6)`
  color: #191919;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
export const TypographyT44 = styled(TypographyT43)`
  color: #000;
  font-weight: 600;
`;
export const TypographyT45 = styled(TypographyT6)`
  color: #627fe9;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  text-decoration-line: underline;
  cursor: pointer;
`;
export const TypographyT46 = styled(TypographyT43)`
  font-weight: 500;
`;
export const TypographyT47 = styled(TypographyT46)`
  color: #038c42;
`;

export const TypographyT48 = styled(TypographyT5)`
  color: #191919;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
export const TypographyT49 = styled(TypographyT48)`
  font-weight: 600;
`;
export const TypographyT50 = styled(TypographyT5)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;
export const TypographyT51 = styled(TypographyT50)`
  font-weight: 600;
`;
export const TypographyT52 = styled(TypographyT4)`
  color: #191919;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;
export const TypographyT53 = styled(TypographyT5)`
  color: #191919;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;
export const TypographyT54 = styled(TypographyT53)`
  font-weight: 400;
`;

export const TypographyT55 = styled(TypographyT4)`
  color: #000;
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
`;

export const TypographyT56 = styled(TypographyT4)`
  color: #000;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
`;

export const TypographyT57 = styled(TypographyT5)`
  color: #000;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.54px;
`;
export const TypographyT58 = styled(TypographyT5)`
  color: #000;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 123.077% */
`;
export const TypographyT59 = styled(TypographyT6)`
color: #EC6263;
font-family: Poppins;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 12px; /* 100% */
background: #FEE;
padding:4px;
border-radius:2px
`;

export const TypographyT60 = styled(TypographyT4)`
  color: #000;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
`;

export const TypographyT61 = styled(TypographyT43)`
  font-size: 12px;
`;
